namespace RioERP.Users {
    export interface VendorsRow {
        Id?: number;
        Name?: string;
        Description?: string;
        BankName?: string;
        BankAccountType?: Web.Enums.BankAccountType;
        BankAccountName?: string;
        BankAccountNo?: string;
        BankIfscCode?: string;
        Address?: string;
        City?: string;
        StateId?: number;
        Country?: string;
        Gstin?: string;
        Pan?: string;
        GstCertificate?: string;
        UserId?: number;
        Pincode?: number;
        IsActive?: boolean;
        Email?: string;
        StateName?: string;
        StateIsActive?: boolean;
        StateInsertUserId?: number;
        StateInsertDate?: string;
        StateUpdateUserId?: number;
        StateUpdateDate?: string;
        StateIsHomeState?: boolean;
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserMobilePhoneNumber?: string;
        UserMobilePhoneVerified?: boolean;
        UserTwoFactorAuth?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace VendorsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Users.Vendors';
        export const lookupKey = 'Users.Vendors';

        export function getLookup(): Q.Lookup<VendorsRow> {
            return Q.getLookup<VendorsRow>('Users.Vendors');
        }
        export const deletePermission = 'Users:UsersManagement:Modify';
        export const insertPermission = 'Users:UsersManagement:Modify';
        export const readPermission = 'Users:UsersManagement:View';
        export const updatePermission = 'Users:UsersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            Description = "Description",
            BankName = "BankName",
            BankAccountType = "BankAccountType",
            BankAccountName = "BankAccountName",
            BankAccountNo = "BankAccountNo",
            BankIfscCode = "BankIfscCode",
            Address = "Address",
            City = "City",
            StateId = "StateId",
            Country = "Country",
            Gstin = "Gstin",
            Pan = "Pan",
            GstCertificate = "GstCertificate",
            UserId = "UserId",
            Pincode = "Pincode",
            IsActive = "IsActive",
            Email = "Email",
            StateName = "StateName",
            StateIsActive = "StateIsActive",
            StateInsertUserId = "StateInsertUserId",
            StateInsertDate = "StateInsertDate",
            StateUpdateUserId = "StateUpdateUserId",
            StateUpdateDate = "StateUpdateDate",
            StateIsHomeState = "StateIsHomeState",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            UserEmail = "UserEmail",
            UserSource = "UserSource",
            UserLastDirectoryUpdate = "UserLastDirectoryUpdate",
            UserUserImage = "UserUserImage",
            UserInsertDate = "UserInsertDate",
            UserInsertUserId = "UserInsertUserId",
            UserUpdateDate = "UserUpdateDate",
            UserUpdateUserId = "UserUpdateUserId",
            UserIsActive = "UserIsActive",
            UserMobilePhoneNumber = "UserMobilePhoneNumber",
            UserMobilePhoneVerified = "UserMobilePhoneVerified",
            UserTwoFactorAuth = "UserTwoFactorAuth",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
